import { createStore } from '@datorama/akita';
import { type User } from 'types/models';

export type UserContextState = Partial<User> & Record<string, any>;

export default createStore<UserContextState>({}, { name: 'userContext', resettable: true });
